/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconBowlingPin: {
  name: 'bowling_pin';
  data: string;
} = {
  name: 'bowling_pin',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M350.657 201.493c1.731-56.742 56.26-191.148-44.662-190.031-.848-.01-1.69-.01-2.516 0-97.497 1.137-43.836 133.767-42.116 190.031h89.294zM355.906 232.493h-99.791c-25.632 84.667-109.321 133.489 8.31 365.615 41.574 3.025 25.163 2.335 41.57 2.395 16.408-.06-.004.63 41.57-2.395 117.632-232.126 33.969-280.948 8.341-365.615z"/></svg>`,
};
